import { CirclePlus } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'
import { useGeckoTheme } from 'styles/GeckoTheme'

export interface AddRowButtonProps {
  onClick: () => void
}

const Root = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  margin: 0;
  padding: 0;
  width: 100%;
  cursor: pointer;
  display: block;
  font: inherit;
  color: inherit;
  text-align: inherit;
  -webkit-tap-highlight-color: transparent;
  opacity: 0.75;

  transition: opacity 160ms ease;

  &:hover {
    opacity: 1;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

const Inner = styled.span`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
`

const Line = styled.span`
  display: block;
  height: 1px;
  background: ${({ theme }) => theme.forecast.secondaryText};
`

export const AddRowButton: React.FC<AddRowButtonProps> = ({ onClick }) => {
  const { theme } = useGeckoTheme()
  return (
    <Root type='button' onClick={onClick} aria-label={'Add row'}>
      <Inner aria-hidden='true'>
        <Line />
        <CirclePlus color={theme.forecast.defaultText} />
        <Line />
      </Inner>
    </Root>
  )
}
